module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 Just Black.db64ed58.png";